export const designTokens = {
  color: {
    surfacePrimary: "#F4F7FB",
    surfaceSecondary: "#E8EEF5",
    surfaceCard: "#FFFFFF",
    brandAccent: "#9F3A2A",
    signal: "#2F7F92",
    textPrimary: "#1F2A37",
    textMuted: "#526172",
    borderSoft: "rgba(71, 85, 105, 0.24)",
  },
  radius: {
    sm: "0.5rem",
    md: "0.75rem",
    lg: "1rem",
    xl: "1.5rem",
  },
  shadow: {
    soft: "0 10px 30px -18px rgba(15, 23, 42, 0.25)",
    elevated: "0 20px 50px -24px rgba(15, 23, 42, 0.3)",
  },
  spacing: {
    xs: "0.25rem",
    sm: "0.5rem",
    md: "0.75rem",
    lg: "1rem",
    xl: "1.5rem",
    "2xl": "2rem",
    "3xl": "3rem",
  },
  zIndex: {
    base: "1",
    dropdown: "20",
    sticky: "30",
    fixed: "40",
    modalBackdrop: "50",
    modal: "60",
    toast: "70",
  },
  motion: {
    fast: 0.18,
    normal: 0.3,
    slow: 0.5,
  },
} as const

export type DesignTokens = typeof designTokens

export function applyDesignTokensToRoot() {
  if (typeof document === "undefined") {
    return
  }

  const root = document.documentElement

  root.style.setProperty("--token-color-surface-primary", designTokens.color.surfacePrimary)
  root.style.setProperty("--token-color-surface-secondary", designTokens.color.surfaceSecondary)
  root.style.setProperty("--token-color-surface-card", designTokens.color.surfaceCard)
  root.style.setProperty("--token-color-brand-accent", designTokens.color.brandAccent)
  root.style.setProperty("--token-color-signal", designTokens.color.signal)
  root.style.setProperty("--token-color-text-primary", designTokens.color.textPrimary)
  root.style.setProperty("--token-color-text-muted", designTokens.color.textMuted)
  root.style.setProperty("--token-color-border-soft", designTokens.color.borderSoft)

  root.style.setProperty("--token-radius-sm", designTokens.radius.sm)
  root.style.setProperty("--token-radius-md", designTokens.radius.md)
  root.style.setProperty("--token-radius-lg", designTokens.radius.lg)
  root.style.setProperty("--token-radius-xl", designTokens.radius.xl)

  root.style.setProperty("--token-shadow-soft", designTokens.shadow.soft)
  root.style.setProperty("--token-shadow-elevated", designTokens.shadow.elevated)

  root.style.setProperty("--token-space-xs", designTokens.spacing.xs)
  root.style.setProperty("--token-space-sm", designTokens.spacing.sm)
  root.style.setProperty("--token-space-md", designTokens.spacing.md)
  root.style.setProperty("--token-space-lg", designTokens.spacing.lg)
  root.style.setProperty("--token-space-xl", designTokens.spacing.xl)
  root.style.setProperty("--token-space-2xl", designTokens.spacing["2xl"])
  root.style.setProperty("--token-space-3xl", designTokens.spacing["3xl"])

  root.style.setProperty("--token-z-base", designTokens.zIndex.base)
  root.style.setProperty("--token-z-dropdown", designTokens.zIndex.dropdown)
  root.style.setProperty("--token-z-sticky", designTokens.zIndex.sticky)
  root.style.setProperty("--token-z-fixed", designTokens.zIndex.fixed)
  root.style.setProperty("--token-z-modal-backdrop", designTokens.zIndex.modalBackdrop)
  root.style.setProperty("--token-z-modal", designTokens.zIndex.modal)
  root.style.setProperty("--token-z-toast", designTokens.zIndex.toast)

  root.style.setProperty("--token-motion-fast", String(designTokens.motion.fast))
  root.style.setProperty("--token-motion-normal", String(designTokens.motion.normal))
  root.style.setProperty("--token-motion-slow", String(designTokens.motion.slow))
}
